"use strict";

exports.__esModule = true;
exports.ChangePartKindUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ChangePartKindActionElement = require("./ChangePartKindActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChangePartKindUserAction = exports.ChangePartKindUserAction = {
  name: "ChangePartKind",
  icon: "add",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartKindUserActionDefinition.label",
    defaultMessage: "Change Part Kind"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartKindUserActionDefinition.description",
    defaultMessage: "Enables user to change part kind"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _ChangePartKindActionElement.ChangePartKindActionElement
  }
};